import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getPricerConfiguration, patchPricerConfiguration } from './pricerIntegration.service'
import useUser from '../../components/Shared/UserProvider/useUser'
import { useCallback } from 'react'

const DEFAULT_PRICER_OPTIONS = {
  enabled: false,
  triggerMode: 0,
  serverAddress: '',
  port: 3333,
  auth_key: '',
  advancedEnabled: false,
}

const QUERY_KEY = (posId) => ['pricer-configuration', posId]

const usePricerOptions = () => {
  const { user } = useUser()
  const posId = user.loginContext.pos?.id
  const queryClient = useQueryClient()

  const { data: options = DEFAULT_PRICER_OPTIONS } = useQuery({
    queryKey: QUERY_KEY(posId),
    queryFn: () => getPricerConfiguration(posId),
    enabled: !!posId,
    select: (config) => ({ ...DEFAULT_PRICER_OPTIONS, ...config }),
  })

  const { mutate } = useMutation({
    mutationFn: (configuration) => patchPricerConfiguration(posId, configuration),
    onMutate: async (configuration) => {
      await queryClient.cancelQueries({ queryKey: QUERY_KEY(posId) })
      queryClient.setQueryData(QUERY_KEY(posId), configuration)
    },
  })

  const setOptions = useCallback((updater) => {
    const current = queryClient.getQueryData(QUERY_KEY(posId)) ?? DEFAULT_PRICER_OPTIONS
    const next = typeof updater === 'function' ? updater(current) : updater
    mutate(next)
  }, [mutate, queryClient, posId])

  return [options, setOptions]
}

export { usePricerOptions, DEFAULT_PRICER_OPTIONS }
